import ivyStore from '@ivy/fts/ivyStore'
import { weixinShare } from '@ivy/fts/weixin'
import conf from './config'
export class Store {
  domain: any = {
    production: 'https://m.ivydad.com',
    test: 'http://m.ivydad.com.cn',
  }[conf.env]
  noApp: boolean = window.location.href.includes('opt=noapp')
  fromQr: boolean = window.location.href.includes('from=qr')
  appSharePromise: any = null
  logined: any = ivyStore.logined
  async login(vue, force = 0) {
    return await ivyStore.login(vue, force)
  }
  async bindPhone(options) {
    return await ivyStore.bindPhone(options)
  }
  async setupShare(options) {
    if (!options) {
      this.appSharePromise = weixinShare({
        link: window.location.href,
        imgUrl:
          'http://service.ivydad.com/tools/imagePageb90c706a-534d-130b-e518-24bbf335810a.png?x-oss-process=image/resize,w_750',
      })
    }
    await this.appSharePromise
    if (options) {
      await weixinShare(options)
    }
  }
}
export default new Store()
